import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrordialogService, IErrorItem } from './errordialog.service';
import { NgIf, NgFor } from '@angular/common';

interface IErrorData {
  ExceptionType: string;
  Errors: IErrorItem[];
}

@Component({
    selector: 'cevi-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor]
})
export class ErrorDialogComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  errorData: IErrorData;

  constructor(private errorDialogService: ErrordialogService) { }

  cancel() {
    this.errorData = null;
  }

  ngOnInit() {
    this.subscription = this.errorDialogService.errorSourceObservable.subscribe(data => {
      this.errorData = data;
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
